/**
 * NavTabSelector — Figma-aligned page-level tab bar.
 *
 * Frosted glass pill with selectable tabs.
 * Selected tab gets midnight-ink pill with border-radius 12px.
 *
 * Props:
 *   tabs    — [{ key: string, label: string }]
 *   active  — key of the currently selected tab
 *   onChange — (key) => void
 *   className — optional extra class(es) for the outer container
 */
import s from './NavTabSelector.module.css';

export default function NavTabSelector({ tabs, active, onChange, className }) {
  return (
    <div role="tablist" className={`${s.tabList}${className ? ` ${className}` : ''}`}>
      {tabs.map((tab) => {
        const isActive = active === tab.key;
        return (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(tab.key)}
            className={`${s.tab} ${isActive ? s.tabActive : ''}`}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
